export type AttributesMapping = Record<string, string>;

const mappingSource: AttributesMapping = {
    // eu
    7607: '83',
    7611: '260',
    7612: '16',
    8261: '118',
    7776: '230',
    7609: '281',
    7684: '112',
    7683: '8160',
    // sensors
    // probeLength
    8439: '7984',

    // am
    8253: '65',
    8262: '223',
};

export function getAltId(id: string): string | null {
    return mappingSource[id] || null;
}
